import React, { useEffect, useState, useRef } from "react";
import Pages from "@/assets/dashboard/pages.png";
function OageDaccueil() {
  return (
    <div style={{ width: "100%" }}>
      <img
        src={Pages}
        alt="pages"
        style={{
          width: "100%",
          height: "2000px",
        }}
      />
    </div>
  );
}

export default OageDaccueil;
